// headerData.js

import resume from '../assets/pdf/Cv_AnasZERHOUN.pdf';

export const headerData = {
    name: {
        en: 'Anas Zerhoun',
        fr: 'Anas Zerhoun'
    },
    title: {
        en: ["Software Engineer",'Creative Coder'],
        fr: ["Ingénieur logiciel",'Codeur Créatif']
    },
    description: {
        en: "Life may be a meandering path but don't worry about it, rather enjoy it. It is about the journey, not the destination so explore all that comes your way, learn and grow from it, for this journey only happens once.",
        fr: "La vie peut être un chemin sinueux, mais ne t'en fais pas, profites-en plutôt. C'est le voyage qui compte, pas la destination, alors explore tout ce qui se présente à toi, apprends et grandis grâce à cela, car ce voyage n'arrive qu'une seule fois."
    },
    image: {
        en: '../assets/me.jpg',
        fr: '../assets/me.jpg'
    },
    resumePdf:resume,
}
